import { GREY_300 } from '@propertypal/shared/src/styles/theme/colors';
import React, { CSSProperties } from 'react';
import WhiteButton from '../buttons/WhiteButton';
import { CallAgentBox, ShowPhoneNumber } from './PropertyPhoneNumberButton.style';

interface PropertyPhoneNumberButtonProps {
  containerStyle?: CSSProperties;
  onCallClick: (location: string) => void;
  onShowNumberClick: (location: string, accountNumber?: string) => void;
  location: string;
  accountNumber?: string;
  useShortText: boolean;
  icon?: any;
  revealNumber?: string | null;
  suffix?: string;
}

const PropertyPhoneNumberButton: React.FC<PropertyPhoneNumberButtonProps> = (props) => {
  return (
    <>
      <ShowPhoneNumber data-testid="showPhoneNumber">
        <WhiteButton
          containerStyle={props.containerStyle}
          onClick={() => {
            if (props.revealNumber) props.onCallClick(props.location);
            else props.onShowNumberClick(props.location, props.accountNumber);
          }}
          testID="showPhoneNumberButton"
          type="button"
          icon={!props.revealNumber && props.icon}
          iconColour={GREY_300}
        >
          {props.revealNumber || (props.useShortText ? 'Call' : `Call the ${props.suffix || 'Agent'}`)}
        </WhiteButton>
      </ShowPhoneNumber>

      <CallAgentBox>
        <WhiteButton
          containerStyle={props.containerStyle}
          onClick={() => props.onCallClick(props.location)}
          testID="callAgentButton"
          type="button"
        >
          {props.useShortText ? 'Call' : `Call the ${props.suffix || 'Agent'}`}
        </WhiteButton>
      </CallAgentBox>
    </>
  );
};

export default PropertyPhoneNumberButton;
